import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import UserFavoritesRepositoriesFactory from '../../userFavorites/Repositories/factory.js'
import GetUserFavoritesService from './GetUserFavoritesService.js'

export default class UserFavoritesServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetUserFavoritesService}
   * @property {HTTPAdsRepository} repository
   */
  static getUserFavoritesService = ({config}) =>
    new GetUserFavoritesService({
      config,
      repository: UserFavoritesRepositoriesFactory.hTTPUserFavoritesRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getUserNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })
}
